import { post } from '@/util/auth'

import type { InjuryReportPayload } from './types'

const injuryReportResources = {
  post: (payload: InjuryReportPayload) => post('form/:code/injury-report', payload),
}

export default injuryReportResources
